import Backbone from "backbone";
import { KeyboardUtil } from '../utils/keyboard-util';

let FormView = Backbone.View.extend({

    events: {
        "click .js-form-view-submit": "onFormSubmit",
        "click .form-group": "onFormReset",
        'keyup' : 'onKeyPress'
    },

    elems: {
        errorMessage: null,
        submitButton: null,
    },

    states: {
        default:    'form-view--default',
        processing: 'form-view--processing',
        success:    'form-view--success',
        error:      'form-view--error'
    },

    initialize: function () {
        this.elems.errorMessage = this.el.querySelector('.js-form-view-errors');
        this.elems.submitButton = this.el.querySelector('.js-form-view-submit');
    },

    onFormSubmit: function(e) {
        if (e) e.preventDefault();

        this.el.classList.remove(this.states.default);
        this.el.classList.remove(this.states.error);
        this.el.classList.add(this.states.processing);

        this.elems.submitButton.setAttribute('disabled', true);
        this.elems.errorMessage.innerHTML = '';

        this.executeOperation()
            .then((data) => { this.onOperationSucceeded(data); })
            .catch((err) => { this.onOperationFailed(err); });
    },

    onOperationSucceeded: function(data) {
        this.el.classList.remove(this.states.processing);
        this.el.classList.add(this.states.success);
    },

    onOperationFailed: function(err) {
        this.elems.errorMessage.innerHTML = err;
        this.el.classList.remove(this.states.processing);
        this.el.classList.add(this.states.error);
        this.elems.submitButton.removeAttribute('disabled');
    },

    onFormReset: function() {
        if (!this.el.classList.contains(this.states.processing)) {
            this.elems.submitButton.removeAttribute('disabled');
            this.el.classList.remove(this.states.success);
            this.el.classList.remove(this.states.error);
            this.el.classList.add(this.states.default);
        }
    },

    onKeyPress: function(e) {
        e.preventDefault();
        const code = e.keyCode || e.which || 0;
        if (code === KeyboardUtil.keyEnter) { this.onFormSubmit(); }
    },

    // must override function for inheriting view classes
    executeOperation: function() {
        return new Promise((resolve, reject) => { resolve(); });
    }
});

FormView.extend = function(child) {
    var view = Backbone.View.extend.apply(this, arguments);
	view.prototype.events = _.extend({}, this.prototype.events, child.events);
	view.prototype.elems = _.extend({}, this.prototype.elems, child.elems);
	return view;
};

export { FormView };